import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_retrieve_product_stock_age_analysis_breakdown: { message: "idle" },
};

export const tenant_retrieve_product_stock_age_analysis_breakdown_Slice = createSlice({
 name: "tenant_retrieve_product_stock_age_analysis_breakdown",
 initialState,
 reducers: {
  success_tenant_retrieve_product_stock_age_analysis_breakdown: (state, action) => {
   state.tenant_retrieve_product_stock_age_analysis_breakdown = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_retrieve_product_stock_age_analysis_breakdown: (state, action) => {
   state.tenant_retrieve_product_stock_age_analysis_breakdown = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_retrieve_product_stock_age_analysis_breakdown: (state) => {
   state.tenant_retrieve_product_stock_age_analysis_breakdown = { status: app_consts.IDLE };
  },
  loading_tenant_retrieve_product_stock_age_analysis_breakdown: (state) => {
   state.tenant_retrieve_product_stock_age_analysis_breakdown = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_retrieve_product_stock_age_analysis_breakdown, fail_tenant_retrieve_product_stock_age_analysis_breakdown, reset_tenant_retrieve_product_stock_age_analysis_breakdown, loading_tenant_retrieve_product_stock_age_analysis_breakdown } = tenant_retrieve_product_stock_age_analysis_breakdown_Slice.actions;

export default tenant_retrieve_product_stock_age_analysis_breakdown_Slice.reducer;